export default {
    LOAD_BOX_HISTORIC(state, box_historic) {

        state.items = box_historic;
    }
}